import React from "react";
// import ProjectKUL from '../../ProjectKUL/ProjectKUL';
import Image6 from "../../../images/Image6.png";
import KUJam from "../../../images/KindnessJam.jpg";
import projectKUL from "../../../images/Project-KUL.jpeg"
import CupKindness from "../../../images/Image4.jpeg";
import Carnival from "../../../images/KUCarnival.jpg";
import Beats from "../../../images/BeatsKU.jpg";
import Dance from "../../../images/danceKU.jpg";
import kindnessProm from "../../../images/kindness-prom.jpg";
import wheelchairCricket from "../../../images/wheelchair-cricket.webp";
import image2 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM (1).jpeg";
import kuAgatsu from "../../../images/KUxAgastu.png";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import CategoryCardGrid from "../../ui/CategoryCardGrid";
import FadeIn from "../../ui/FadeIn";


const WKW = () => (
  <PageLayout>
    <PageHero title="Volunteering" light />
    <section className="ku-section bg-ku-cream space-y-12">
      <div className="ku-container">
        <FadeIn><p className="font-display text-xl font-semibold text-ku-royal mb-6">2025:</p></FadeIn>
        <CategoryCardGrid
          cards={[
            { to: "/project-kul", image: projectKUL, title: "Project KUL" },
            { to: "./agatsushowcase", image: kuAgatsu, title: "Kindness Connect" },
            { to: "./kindnessprom", image: kindnessProm, title: "Kindness Prom" },
            { to: "./wheelchaircricket", image: wheelchairCricket, title: "Wheelchair Cricket Tournament" },
            { to: "/engagements/daanutsav", image: image2, title: "Daan Utsav" },
          ]}
          columns={3}
          bare
        />
      </div>
      <div className="ku-container">
        <FadeIn><p className="font-display text-xl font-semibold text-ku-royal mb-6">2020:</p></FadeIn>
        <CategoryCardGrid
          cards={[
            { to: "./cupofkindness", image: CupKindness, title: "Cup Of Kindness" },
            { to: "./carnival", image: Carnival, title: "Kindness Carnival" },
          ]}
          columns={2}
          bare
        />
      </div>
      <div className="ku-container">
        <FadeIn><p className="font-display text-xl font-semibold text-ku-royal mb-6">2019:</p></FadeIn>
        <CategoryCardGrid cards={[{ to: "./kindnessjam", image: KUJam, title: "The Kindness Jam" }]} columns={1} bare />
      </div>
      <div className="ku-container">
        <FadeIn><p className="font-display text-xl font-semibold text-ku-royal mb-6">2018:</p></FadeIn>
        <CategoryCardGrid cards={[{ to: "./fooddistribution", image: Image6, title: "Food Distribution" }]} columns={1} bare />
      </div>
      <div className="ku-container">
        <FadeIn><p className="font-display text-xl font-semibold text-ku-royal mb-6">Other events</p></FadeIn>
        <CategoryCardGrid
          cards={[
            { to: "./beats", image: Beats, title: "Beats of a Kind" },
            { to: "./dancekindness", image: Dance, title: "Dance for Kindness" },
          ]}
          columns={2}
          bare
        />
      </div>
    </section>
  </PageLayout>
);

export default WKW;
